
import { computed, defineComponent } from 'vue';
import { HIDE_BORDER } from '@/types/enums';

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    hideBorder: { type: Number as () => HIDE_BORDER, default: HIDE_BORDER.NONE },
    error: { type: String, default: '' },
    id: { type: String, default: '' },
  },
  setup(props) {
    const objectClass = computed(() => ({
      'no-bottom-border': props.hideBorder === HIDE_BORDER.BOTTOM,
      'no-top-border': props.hideBorder === HIDE_BORDER.TOP,
      'no-border': props.hideBorder === HIDE_BORDER.ALL,
      error: props.error,
    }));

    return {
      objectClass,
    };
  },
});
